import React, { useEffect, useRef } from 'react';
import { createPortal } from 'react-dom';

export default function ReferralDialog({ children, busy, onClose }) {
  const dialog = useRef(null);
  const close = useRef(onClose);
  const saving = useRef(busy);
  close.current = onClose;
  saving.current = busy;

  useEffect(() => {
    const trigger = document.activeElement;
    const overflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    dialog.current.focus();
    function keydown(event) {
      if (event.key === 'Escape') {
        event.preventDefault();
        if (!saving.current) close.current();
      }
      if (event.key === 'Tab') {
        const controls = Array.from(dialog.current.querySelectorAll('button:not(:disabled), select:not(:disabled), textarea:not(:disabled), input:not(:disabled), a[href], [tabindex="0"]'));
        const first = controls[0];
        const last = controls[controls.length - 1];
        if (!first) { event.preventDefault(); dialog.current.focus(); }
        else if (event.shiftKey && (document.activeElement === first || document.activeElement === dialog.current)) { event.preventDefault(); last.focus(); }
        else if (!event.shiftKey && (document.activeElement === last || document.activeElement === dialog.current)) { event.preventDefault(); first.focus(); }
      }
    }
    document.addEventListener('keydown', keydown);
    return () => {
      document.body.style.overflow = overflow;
      document.removeEventListener('keydown', keydown);
      if (trigger?.isConnected) trigger.focus();
    };
  }, []);

  return createPortal(<div className="fixed inset-0 z-50 flex items-center justify-center bg-gray-800 bg-opacity-50 p-4" onClick={event => { if (event.target === event.currentTarget && !busy) onClose(); }}>
    <div ref={dialog} role="dialog" aria-modal="true" aria-labelledby="referral-dialog-title" tabIndex={-1} className="max-h-full w-full max-w-4xl overflow-y-auto rounded-lg bg-white p-5 shadow-xl outline-none md:p-8 space-y-6">{children}</div>
  </div>, document.body);
}
